module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("渠道管理")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.queryParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "channelName", $$v)
      },
      expression: "queryParams.channelName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "获客终端"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "channelType", $$v)
      },
      expression: "queryParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "type", $$v)
      },
      expression: "queryParams.type"
    }
  }, _vm._l((this.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "市场分类"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.marketCategory),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "marketCategory", $$v)
      },
      expression: "queryParams.marketCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": "__NONE__"
    }
  }, [_vm._v("未分类")]), _vm._v(" "), _vm._l((_vm.marketCategoryNames), function(name) {
    return _c('Option', {
      key: name,
      attrs: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  })], 2)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "来源"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "tchChannel", $$v)
      },
      expression: "queryParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            搜索\n          ")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toshowAddChannelModal
    }
  }, [_vm._v("\n          新建市场渠道\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "channelList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/channel/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('CreateChannelModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddChannelModal),
      callback: function($$v) {
        _vm.showAddChannelModal = $$v
      },
      expression: "showAddChannelModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑渠道"
    },
    model: {
      value: (_vm.showUpdateChannelModal),
      callback: function($$v) {
        _vm.showUpdateChannelModal = $$v
      },
      expression: "showUpdateChannelModal"
    }
  }, [_c('Form', {
    ref: "updateChannelForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.channelRules,
      "model": _vm.updateChannelParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道名称：",
      "prop": "channelName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.updateChannelParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelName", $$v)
      },
      expression: "updateChannelParams.channelName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道分类：",
      "prop": "channelType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateChannelParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelType", $$v)
      },
      expression: "updateChannelParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道参数：",
      "prop": "channelParam"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道参数"
    },
    model: {
      value: (_vm.updateChannelParams.channelParam),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "channelParam", $$v)
      },
      expression: "updateChannelParams.channelParam"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateChannelParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "status", $$v)
      },
      expression: "updateChannelParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updateChannelParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "tchChannel", $$v)
      },
      expression: "updateChannelParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道描述："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入渠道描述"
    },
    model: {
      value: (_vm.updateChannelParams.description),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "description", $$v)
      },
      expression: "updateChannelParams.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "市场专员"
    }
  }, [_c('AdminUserMultSelect', {
    attrs: {
      "status": 1,
      "groupTitles": ['市场运营', '市场专员', '代理']
    },
    model: {
      value: (_vm.updateChannelParams.adminUserIds),
      callback: function($$v) {
        _vm.$set(_vm.updateChannelParams, "adminUserIds", $$v)
      },
      expression: "updateChannelParams.adminUserIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateChannelModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.updateChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab835254","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/ChannelManagement.vue
// module id = 1945
// module chunks = 8